import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Credential is always required
  if (!properties.credentialId) {
    errors.push({ key: 'credentialId', message: 'Asana credential is required' });
  }

  const resource = properties.resource;
  const operation = properties.operation;

  // Resource-specific validation
  switch (resource) {
    case 'task':
      if (['get', 'delete', 'update', 'move'].includes(operation) && !properties.taskGid) {
        errors.push({ key: 'taskGid', message: 'Task GID is required' });
      }
      if (operation === 'create') {
        if (!properties.workspaceGid) errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
        if (!properties.taskName) errors.push({ key: 'taskName', message: 'Task name is required' });
      }
      if (operation === 'getMany') {
        if (!properties.workspaceGid) errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
        if (!properties.projectGid) errors.push({ key: 'projectGid', message: 'Project is required' });
      }
      if (operation === 'search') {
        if (!properties.workspaceGid) errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
        if (!properties.searchText) errors.push({ key: 'searchText', message: 'Search text is required' });
      }
      if (operation === 'move') {
        if (!properties.taskGid) errors.push({ key: 'taskGid', message: 'Task GID is required' });
        if (!properties.sectionGid) errors.push({ key: 'sectionGid', message: 'Section is required' });
      }
      break;

    case 'project':
      if (['get', 'delete', 'update'].includes(operation) && !properties.projectGid) {
        errors.push({ key: 'projectGid', message: 'Project GID is required' });
      }
      if (operation === 'create') {
        if (!properties.workspaceGid) errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
        if (!properties.projectName) errors.push({ key: 'projectName', message: 'Project name is required' });
      }
      if (operation === 'getMany' && !properties.workspaceGid) {
        errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
      }
      break;

    case 'subtask':
      if (!properties.parentTaskGid) {
        errors.push({ key: 'parentTaskGid', message: 'Parent task GID is required' });
      }
      if (operation === 'create' && !properties.subtaskName) {
        errors.push({ key: 'subtaskName', message: 'Subtask name is required' });
      }
      break;

    case 'taskComment':
      if (operation === 'add') {
        if (!properties.taskGid) errors.push({ key: 'taskGid', message: 'Task GID is required' });
        if (!properties.commentText) errors.push({ key: 'commentText', message: 'Comment text is required' });
      }
      if (operation === 'remove' && !properties.storyGid) {
        errors.push({ key: 'storyGid', message: 'Story GID is required' });
      }
      break;

    case 'taskProject':
      if (!properties.taskGid) errors.push({ key: 'taskGid', message: 'Task GID is required' });
      if (!properties.projectGid) errors.push({ key: 'projectGid', message: 'Project GID is required' });
      break;

    case 'taskTag':
      if (!properties.taskGid) errors.push({ key: 'taskGid', message: 'Task GID is required' });
      if (!properties.tagGid) errors.push({ key: 'tagGid', message: 'Tag is required' });
      break;

    case 'user':
      if (operation === 'get' && !properties.userGid) {
        errors.push({ key: 'userGid', message: 'User GID is required' });
      }
      if (operation === 'getMany' && !properties.workspaceGid) {
        errors.push({ key: 'workspaceGid', message: 'Workspace is required' });
      }
      break;
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
